import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { StartupModule } from '@core/startup/startup.module';
import { SharedModule } from '@core/shared/shared.module';
import { CustomAdapter, CustomDateParserFormatter } from './shared';
import { PreloginModule } from '@core/prelogin';
import {
    HomeModule, LegalPageModule, PointsummaryModule, SalesClaimModule, CouponclaimModule, InvoiceclaimModule, QuizQuestionnaireModule, GameModule,
    GoalQuestModule, MyPerformanceModule, MyAwardsModule, EmbeddedReportModule, MessagePageModule, QuestionPageModule, ContentPageModule, LeagueModule,
    HubPageModule, AccountsModule, TabViewModule, CommunicationModule, RegistrationApprovalModule
} from '@app/core/private';
import { MyThresholdAwardsModule } from './private/mythresholdawards/my-threshold-awards.module';
import { MembershipTieringModule } from './private/membership-tiering/membership-tiering-modules';
import { NotificationCornerModule } from './private/notificationcorner';
import { LeaderboardModule } from './private/leaderboard';


@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        TranslateModule,
        ToastrModule.forRoot({ maxOpened: 1, preventDuplicates: true }),
        StartupModule,
        SharedModule,
        HomeModule,
        LegalPageModule,
        PreloginModule,
        PointsummaryModule,
        CouponclaimModule,
        InvoiceclaimModule,
        SalesClaimModule,
        GoalQuestModule,
        QuizQuestionnaireModule,
        GameModule,
        MyPerformanceModule,
        MyAwardsModule,
        EmbeddedReportModule,
        MessagePageModule,
        QuestionPageModule,
        ContentPageModule,
        LeagueModule,
        LeaderboardModule,
        HubPageModule,
        AccountsModule,
        MyThresholdAwardsModule,
        MembershipTieringModule,
        NotificationCornerModule,
        TabViewModule,
        CommunicationModule,
        RegistrationApprovalModule
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
    ]
})
export class AppCoreModule { }